<script lang="ts">
  import { goto } from '$app/navigation';

  import { inview } from 'svelte-inview';

  import type { CommonDto } from '@do/data-transfer-objects';
  import { DirectusImage, Preset, type PictureSizes } from '@do/svelte-directus-images';

  // import { seamlessImageNavigation } from '@shared/ui/transition-animator/helpers';
  import { pointer } from '@shared/libs/tools';
  import { Icon } from '@shared/ui/icon';
  import { TextUnderline } from '@shared/ui/text-underline';
  import { is, truncateString } from '@shared/utils';
  import { getPrice } from '@shared/utils/blockchain';

  import { walletSidebarActivity } from '@widgets/wallet-sidebar/model';

  import { TRANSITION_DELAY_BETWEEN_IMAGE_AND_FIRST_LINE, TRANSITION_DELAY_BETWEEN_LINES } from '../config/constants';
  import { imageIdToNumber } from '../libs';

  export let image: CommonDto.Photo | null;
  export let name: string;
  export let price: number | null;
  export let year: string | null | undefined = undefined;
  export let artist: string | null;
  export let slug: string;
  // export let status: TokenStatus;
  export let breakpoints: PictureSizes = {
    // TODO - do not use default
    default: '400px',
    'min-768': 'calc(100vw - 40px)',
  };
  export let hasHover = true;

  // let isVisible = false;
  let wasInview = false;
  let isImageLoaded = false;
  let imgElement: HTMLImageElement;
  $: isVisible = isImageLoaded && wasInview;

  //animations
  const options = { rootMargin: '0px', threshold: 0.1 };

  const appearanceDelay = imageIdToNumber(image?.id); // get up to 3 digit value from image id. Additional check cuz we have cases where image is undefined

  $: opacityTransitionClasses = `transition-opacity ${is(isVisible, 'opacity-1', 'opacity-0')} duration-500`;

  const getTransitionDelay = (order: number): string =>
    `${appearanceDelay + TRANSITION_DELAY_BETWEEN_IMAGE_AND_FIRST_LINE + TRANSITION_DELAY_BETWEEN_LINES * order}ms`;

  function handleEnter() {
    wasInview = true;
  }

  function handleImageLoad() {
    isImageLoaded = true;
  }
</script>

<!-- on:click="{(e) => seamlessImageNavigation(e, imgElement)}" -->
<!-- TODO improve wallet sidebar activity close on goto -->
<a
  href="/{slug}/"
  draggable="false"
  on:click="{() => {
    goto(`/${slug}/`);
    walletSidebarActivity.close();
  }}"
  use:inview="{options}"
  on:inview_enter="{handleEnter}"
>
  <div
    class="group relative w-full break-inside-avoid transition-transform duration-500 {is(
      hasHover,
      'hover:scale-[102%]',
    )}"
  >
    <div
      class="{is(
        isVisible,
        'opacity-1 translate-y-0 scale-100',
        'translate-y-[80%] scale-75 opacity-0',
      )} mb-2 overflow-hidden [transition:opacity_0.5s,transform_0.8s]
  "
      style="transition-delay: {appearanceDelay}ms;"
    >
      <div
        class="
      bg-default-100 dark:bg-dark-350 relative w-full cursor-pointer rounded-lg p-2.5
      {is(isVisible, 'translate-y-0', '-translate-y-[60%]')} [transition:transform_0.8s]
      "
        use:pointer="{'view'}"
        style="transition-delay: {appearanceDelay}ms;"
      >
        <DirectusImage
          imageData="{image}"
          alt="{name}"
          imgClasses="w-full max-w-fit max-h-full m-auto object-contain aspect-square"
          attributes="{{
            draggable: false,
          }}"
          pictureSizes="{breakpoints}"
          presetKeys="{Preset.Thumbnail}"
          on:load="{handleImageLoad}"
          bind:imgElement
        />
      </div>
    </div>

    <div class="flex justify-between">
      <div class="max-w-full text-sm">
        {#if artist}
          <p
            class="{opacityTransitionClasses} hover:decoration-default-900 dark:hover:decoration-default-50 inline-block max-w-full break-words font-bold underline decoration-transparent decoration-1 underline-offset-[6px] transition-[text-decoration-color] duration-300"
            style="transition-delay: {getTransitionDelay(1)}"
          >
            {artist}
          </p>
        {/if}

        <p class="{opacityTransitionClasses}" style="transition-delay: {getTransitionDelay(2)}" title="{name}">
          <TextUnderline>
            {truncateString(name, 150)}{#if year}, {year}{/if}
          </TextUnderline>
        </p>

        {#if price}
          <div class="{opacityTransitionClasses}" style="transition-delay: {getTransitionDelay(4)}">
            <div class="flex items-center gap-1">
              <Icon name="usdc" width="{16}" height="{16}" classes="pt-[0.5px] pb-[1px]" />

              <div>
                <span class="text-base font-medium">
                  {getPrice(price)}
                </span>

                <span class="text-sm font-medium leading-4">USDC</span>
              </div>
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>
</a>
